// extracted by mini-css-extract-plugin
export var container = "_gw-1";
export var cornerButtonContainer = "_gw-6";
export var disabled = "_gw-2";
export var dragActive = "_gw-3";
export var fileContainer = "_gw-5";
export var hiddenInput = "_gw-4";
export var widthContainer = "_gw-0";